<div class="content-area">
  <div class="title-block">
    <div class="title-block__filter placehold">
      <h1 class="placehold">{{title}} </h1>
      <a *ngIf="false" class="filter-action" href="javascript:void(0);"
        [ngClass]="clickEventFilterStatus ? 'active' : 'inactive'" (click)="clickEventFilter()">Actions</a>
    </div>

    <p class="janos-name" *ngIf="SalesOrderFound || AppointmentFound">
      <strong>"{{searchText}}"</strong> found in <strong *ngIf="SalesOrderFound">Not Scheduled</strong>
      <span *ngIf="SalesOrderFound && AppointmentFound"> & </span>
      <strong *ngIf="AppointmentFound">Scheduled</strong> appointment(s)
    </p>
  </div>

  <p-tabView class="tab-outer appointments-tab-outer" [activeIndex]="index" (onChange)="handleChange($event)">
    <p-tabPanel header="Not Scheduled" class="dummyClassNSch">
      <ng-template pTemplate="content">
        <div *ngIf="false" class="appointments-top-block" [ngClass]="clickEventFilterStatus ? 'active' : 'inactive'">
          <div class="appointments-top-block__box"
            [ngClass]="{'active': i===selectedfilterIndex,'inactive': i!=selectedfilterIndex,'nocursor': salesOrderCount.salesOrderCount== 0}"
            *ngFor="let salesOrderCount of salesOrderCountModels;let i=index">
            <span class="appointments-top-block__box__numbers"
              (click)="salesOrderCount.salesOrderCount > 0 && onSalesOrderCountClick(salesOrderCount,i);">{{salesOrderCount.salesOrderCount}}</span>
            <div (click)="salesOrderCount.salesOrderCount > 0 && onSalesOrderCountClick(salesOrderCount,i);">
              {{salesOrderCount.salesOrderStatusDisplayble}}
            </div>
          </div>
        </div>

        <a *ngIf="false" class="appt-table-action-click" href="javascript:void(0);"
          (click)="actionsClickNotScheduled.toggle($event)">Actions</a>

        <p-popover appendTo="body" #actionsClickNotScheduled [dismissable]="true">
          <div class="appt-listing-action">
            <div class="appt-listing-action__block">
              <ul>
                <li *ngFor="let salesOrderCount of salesOrderCountModels;let i=index">
                  <a href="javascript:void(0);" [class.disabled]="salesOrderCount.salesOrderCount== 0"
                    [ngClass]="{'active': i===selectedfilterIndex,'inactive': i!=selectedfilterIndex,'nocursor': salesOrderCount.salesOrderCount== 0}"
                    (click)="salesOrderCount.salesOrderCount > 0 && onSalesOrderCountClick(salesOrderCount,i);">
                    <span class="text">
                      {{salesOrderCount.salesOrderStatusDisplayble}}
                    </span>
                    <span class="numbers"
                      (click)="salesOrderCount.salesOrderCount > 0 && onSalesOrderCountClick(salesOrderCount,i);">{{salesOrderCount.salesOrderCount}}</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </p-popover>

        <div class="appointments-table-filer">
          <div class="appointments-table-filer__appit-legend">
            <ul>
              <li>
                <span class="legend ready-for-scheduling" (click)="onAppointmentFilterStatus('Ready For Scheduling')">
                  Ready For Scheduling ({{salesorderStatusCountModel?.readyForScheduling >0 ?
                  salesorderStatusCountModel?.readyForScheduling : 0
                  }})
                </span>
              </li>
              <li *ngIf="!this.searchRequestModel?.isFromDashboard">
                <span class="legend no-show" (click)="onAppointmentFilterStatus('No Show')">
                  No Show
                  ({{salesorderStatusCountModel?.noShow >0 ? salesorderStatusCountModel?.noShow : 0}})
                </span>
              </li>
              <li *ngIf="!this.searchRequestModel?.isFromDashboard">
                <span class="legend cancel" (click)="onAppointmentFilterStatus('Cancel')">
                  Cancelled
                  ({{salesorderStatusCountModel?.cancel >0 ? salesorderStatusCountModel?.cancel : 0}})
                </span>
              </li>
            </ul>
          </div>
          <div class="appointments-table-filer__sort-by">
            <div class="from__group list-search-outer">
              <div class="search-box">
                <input type="text" class="form__control" pInputText placeholder="S/O ID, Patient & DOB" #searchBox
                  (keyup.enter)="onSearchButtonClick();">

                <button *ngIf="searchBox.value !=''" class="clear-btn" type="button"
                  (click)="searchBox.value ='';onSearchButtonClick();">
                  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.6524 1.54489L1.23901 13.5955M13.6524 13.5955L1.23901 1.54489L13.6524 13.5955Z"
                      stroke="#363636" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </button>
                <button class="search-btn" pButton type="button">
                  <i class="search-new"></i>
                </button>
              </div>
            </div>


            <a href="javascript:void(0);" class="filter-show-hide" (click)="filterCLick.toggle($event)"
              pTooltip="Actions" tooltipPosition="left">
              <svg width="21" height="5" viewBox="0 0 21 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="2.5" cy="2.5" r="2.5" fill="#707070"></circle>
                <circle cx="10.5" cy="2.5" r="2.5" fill="#707070"></circle>
                <circle cx="18.5" cy="2.5" r="2.5" fill="#707070"></circle>
              </svg>
            </a>

            <p-popover appendTo="body" #filterCLick class="search-filter">
              <div class="quick-link-menu">
                <ul>
                  <li *ngIf="isSendInvitationPermission">
                    <a class="invite-schedule" routerLinkActive="active" href="javascript:void(0)"
                      (click)="SendInvitationforAppointment();">Send Invite</a>
                  </li>
                  <li>
                    <a class="invite-schedule" href="javascript:void(0)" routerLinkActive="active"
                      (click)="LockAppoinments()"
                      [ngClass]="isDisabledLock?'invite-schedule disable':'invite-schedule'">Assign Calls</a>
                  </li>
                  <li *ngIf="isLockedAppointments">
                    <a class="invite-schedule" routerLinkActive="active" href="javascript:void(0)"
                      (click)="ViewLockedAppoinments()">View Assigned Calls</a>
                  </li>
                  <li>
                    <a class="invite-schedule" href="javascript:void(0)" routerLinkActive="active"
                      (click)="totalRecords > 0 ? ExportNS(): ''">Export</a>
                  </li>
                  <li>
                    <a class="invite-schedule" href="javascript:void(0)" routerLinkActive="active"
                      (click)="totalRecords > 0 ? CancelVoidAllAppointmentS('voidreview',true): ''">Void Review</a>
                  </li>
                  <li>
                    <a class="invite-schedule" href="javascript:void(0)" routerLinkActive="active"
                      (click)="totalRecords > 0 ? CancelVoidAllAppointmentS('void',true): ''">Void</a>
                  </li>
                  <li>
                    <a class="invite-schedule" href="javascript:void(0)" routerLinkActive="active"
                      (click)="totalRecords > 0 ? SendVoiceMail(true): ''">Voice Mail</a>
                  </li>
                </ul>
              </div>
            </p-popover>

            <a href="javascript:void(0);" class="filter-block" (click)="NotScheduledAddColumn.toggle($event)"
              pTooltip="Column Display Settings" tooltipPosition="left" positionStyle="column-display">
              <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.0525 2.89474H15.2104" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M11.4211 1V4.78946" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M11.421 2.89474H1" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M4.78946 9.5263H1" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M8.57886 7.63157V11.421" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M18.9999 9.5263H8.57886" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M18.0525 16.1579H15.2104" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M11.4211 14.2631V18.0526" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M11.421 16.1579H1" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </a>

            <a href="javascript:void(0);" class="filter-block filter-show-hide" pTooltip="Filters"
              tooltipPosition="right" (click)="tableFilterNotScheduled.toggle($event)">
              <img src="assets/img/filter-ic.svg" width="18" alt="filters">
            </a>

            <p-popover #tableFilterNotScheduled class="search-filter" [dismissable]="true" showCloseIcon="true">
              <div class="search-box-outer">
                <h2 class="filter-title">Filters</h2>
                <a href="javascript:void(0);" class="filter-close" (click)="tableFilterNotScheduled.toggle($event); onClearNSFilterSearch();">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                    <path d="M18.2116 2.8568L2.78845 18.1432" stroke="#3E3E3E" stroke-width="2.5"/>
                    <path d="M18.143 18.2116L2.85657 2.78844" stroke="#3E3E3E" stroke-width="2.5"/>
                  </svg>
                </a>
                <div class="form__group quick-date-filter-box">
                  <label class="form__label">Entry Date Filters</label>
                  <div class="search-box">
                    <input matInput class="form__control" ngxDaterangepickerMd placeholder="Quick Filters"
                      [showCustomRangeLabel]="true" [alwaysShowCalendars]="true" [customRangeDirection]="true"
                      [(ngModel)]="NSSelectedDateRange" [ranges]="ranges" [showCancel]="true" [linkedCalendars]="true"
                      [isTooltipDate]="isTooltipDate" [isInvalidDate]="isInvalidDate" [locale]="callocales"
                      [keepCalendarOpeningWithRange]="true" [showRangeLabelOnInput]="true" [showClearButton]="true" />
                    <button class="search-btn">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M6.84236 13.684C7.52019 13.6838 8.18931 13.5825 8.8288 13.387C10.1919 12.9704 11.7882 12.9978 12.7961 14.0056L14.186 15.3954C14.5199 15.7293 15.0613 15.7293 15.3953 15.3954C15.7292 15.0614 15.7292 14.5199 15.3953 14.186L14.0057 12.7965C12.9978 11.7886 12.9706 10.1922 13.3874 8.82909C13.5831 8.18941 13.6846 7.52007 13.6847 6.84199C13.6847 3.06949 10.6151 0 6.84236 0C3.06965 0 0 3.06949 0 6.84199C0 10.6145 3.06965 13.684 6.84236 13.684ZM6.84236 1.7105C9.67253 1.7105 11.9741 4.01197 11.9741 6.84199C11.9741 9.67201 9.67253 11.9735 6.84236 11.9735C4.01219 11.9735 1.71059 9.67201 1.71059 6.84199C1.71059 4.01197 4.01219 1.7105 6.84236 1.7105Z"
                          fill="#3E3E3E" />
                      </svg>
                    </button>
                  </div>

                </div>

                <div class="from__group">
                  <label class="form__label">Branch</label>
                  <p-select class="form__dropdown select-box" filter="true"  [options]="branchResponseModel"
                    [(ngModel)]="selectedNSbranch" id="branchDropdown" placeholder="Select Branch"
                    optionLabel="crmBranchName"  (onChange)="onBranchChange($event)"></p-select>
                </div>
                <div class="from__group">
                  <label class="form__label">Classification Type</label>
                  <p-multiSelect class="form__multiSelect select-box" [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="selectedClassificationType" [options]="filterClassificationList" placeholder="Select"
                    (onChange)="onClassificationTypeChange($event.value)" optionLabel="crmClassificationDisplayName"
                    [showToggleAll]="false" [selectionLimit]="5"
                    selectedItemsLabel="{0} Classification Selected"></p-multiSelect>
                  <small>[You can select max 5 items at a time]</small>
                </div>

                <div class="from__group">
                  <label class="form__label">Doctor</label>
                  <p-select class="form__dropdown select-box"  filter="true"  [options]="doctorResponseModel" name="Doctors"
                    placeholder="Select Doctor" [(ngModel)]="selectedDoctorResponseModel"
                    (onChange)="onDoctorChange($event)" optionLabel="doctorFullName" [filter]="true">
                  </p-select>
                </div>

                <div class="from__group">
                  <label class="form__label">Facility</label>
                  <p-select class="form__dropdown select-box" filter="true"  [options]="facilityResponseModelDropdownList" name="Doctors"
                    placeholder="Select Doctor Facility" [(ngModel)]="selectedfacilityResponseModel"
                    (onChange)="onFacilityChange($event)" optionLabel="crmFacilityName" 
                    [filter]="true">
                  </p-select>
                </div>
                <div class="from__group">
                  <label class="form__label">Time Zone</label>
                  <p-multiSelect class="form__multiSelect select-box" [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="selectedTimeZone" [options]="timeZoneList" placeholder="Select"
                    (onChange)="onTimeZoneChange($event.value)" optionLabel="appStandardTimeZoneName"
                    selectedItemsLabel="{0} Time Zone Selected"></p-multiSelect>
                </div>

                <div class="from__group">
                  <label class="form__label">Primary Insurance</label>
                  <p-multiSelect class="form__multiSelect select-box"[ngModelOptions]="{standalone: true}"
                    [(ngModel)]="selectedPrimaryInsuranceProvider" [options]="primaryInsuranceProviderList"
                    placeholder="Select" (onChange)="onPrimaryInsurationProviderChange($event.value)"
                    optionLabel="crmPolicyHolderName" [showToggleAll]="false" [selectionLimit]="5"
                    selectedItemsLabel="{0} Primary Insurance Provider Selected"></p-multiSelect>
                  <small>[You can select max 5 items at a time]</small>
                </div>

                <div class="from__group">
                  <label class="form__label">Current Status (calls)</label>
                  <p-multiSelect class="form__multiSelect select-box" [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="selectedCallType" [options]="FilterExactDate" placeholder="Select"
                    (onChange)="onAwaitingCallTypesChange($event.value)" optionLabel="title" [showToggleAll]="false"
                    selectedItemsLabel="{0} Current call status Selected"></p-multiSelect>
                </div>


                <div class="btn-block app-not-scheduled-appointments-btn">
                  <button class="btn btn--primary"
                    (click)="onFilterSearch();closeSearchFilter($event, tableFilterNotScheduled);">Search</button>
                  <a class="btn btn--secondary clear-filter" href="javascript:void(0)"
                    (click)="onClearNSFilterSearch();onFilterSearch();">
                    Clear
                  </a>
                </div>
              </div>
            </p-popover>
          </div>
        </div>


        <div class="page-scroll appointments-list app-not-scheduled-list"
          [ngClass]="filterShowHide ? 'filter-active' : 'filter-inactive'">
          <div class="appointments-scroll-inner-side">
            <p-table #table [ngClass]="isOnlyNonSFixedColumnVisible ? 'onlyvisiblecolumn' : ''"
              class="table-outer appt-not-scheduled" sortMode="single" [sortOrder]="1" sortField="crmPatientName"
              [paginator]="totalRecords>0?true:false" [rows]="getTotalRows()" [totalRecords]="totalRecords"
              [lazy]="true" [customSort]="true" [first]="searchRequestModel.FirstRecordIndex" [value]="salesOrders"
              (onLazyLoad)="onLazyLoad($event)" [(selection)]="selectedsalesOrders" selectionMode=""
              (selectionChange)="onSelectionChange($event)" [columns]="userNonSPreferenceColumn" 
              [scrollable]="true"
              scrollHeight="calc(100vh - 258px)" dataKey="crmSalesOrderId" scrollDirection="both">

              <ng-template pTemplate="header" let-columns>
                <tr *ngIf="totalRecords > 0">
                  <th class="table-outer__th appt-action-column" pFrozenColumn></th>
                  <th class="table-outer__th appt-so-id" pFrozenColumn>
                    <span class="table-header-flex">
                      <p-tableHeaderCheckbox #headerCheckBox></p-tableHeaderCheckbox>
                      <span class="header-soid__name">S/O ID</span>
                    </span>
                  </th>
                  <th class="table-outer__th appt-patient-name" pFrozenColumn pSortableColumn="crmPatientName">
                    Patient details
                    <p-sortIcon field="crmPatientName"></p-sortIcon>
                  </th>
                  <th class="table-outer__th appt-classification" pFrozenColumn pSortableColumn="crmClassification">
                    Classification Type
                    <p-sortIcon field="crmClassification"></p-sortIcon>
                  </th>
                  <th class="table-outer__th appt-status" pFrozenColumn pSortableColumn="crmSalesorderStatus">
                    Status
                    <p-sortIcon field="crmSalesorderStatus"></p-sortIcon>
                  </th>

                  <!-- All Display Column none then it will show *ngIf="isOnlyNonSFixedColumnVisible" -->
                  <!-- <ng-container styleClass="displaycolumn ">
                   <th class="table-outer__th table-outer__displaycolumn"></th>
                  </ng-container> -->

                  <ng-container *ngFor="let co of columns">
                    <th
                      *ngIf="co.field != 'crmPatientName && crmClassification && crmSalesorderStatus' && co.visible===true"
                      class="table-outer__th" pSortableColumn="{{co.sortFieldName}}">
                      {{co.header}}
                      <p-sortIcon field="{{co.field}}"></p-sortIcon>
                    </th>
                  </ng-container>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-salesorder let-columns="columns">
                <tr>
                  <td class="table-outer__td appt-action-column" pFrozenColumn>
                    <a class="actionmenu-btn" href="javascript:void(0)"
                      (click)="selectNonScheduleSalesOrder($event,salesorder,NotScheduledAction)">
                      <svg id="Layer_1" class="appt-action-icon" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 29.96 122.88">
                        <path class="cls-1"
                          d="M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Zm0,92.93a15,15,0,1,1-15,15,15,15,0,0,1,15-15Zm0-46.47a15,15,0,1,1-15,15,15,15,0,0,1,15-15Z" />
                      </svg>
                    </a>

                    <p-popover class="table-action-popup NotScheduledAction appointment-Action"
                      #NotScheduledAction>
                      <ul class="quick-link-menu">
                        <li
                          *ngIf="!selectedSalesOrder.schIsLocked && isAppointmentScheduledPermission && selectedSalesOrder.crmSalesorderStatus != 'No Show'&& selectedSalesOrder.crmSalesorderStatus != 'Cancel'">
                          <a href="javascript:void(0)" (click)="showDialog(selectedSalesOrder)">
                            <svg version="1.1" id="Capa_1" fill="#6F64A7" xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.867 477.867"
                              style="enable-background:new 0 0 477.867 477.867;" xml:space="preserve">
                              <g>
                                <g>
                                  <path d="M426.667,51.2h-51.2V17.067C375.467,7.641,367.826,0,358.4,0s-17.067,7.641-17.067,17.067V51.2h-204.8V17.067
                                    C136.533,7.641,128.892,0,119.467,0S102.4,7.641,102.4,17.067V51.2H51.2C22.923,51.2,0,74.123,0,102.4v324.267
                                    c0,28.277,22.923,51.2,51.2,51.2h375.467c28.277,0,51.2-22.923,51.2-51.2V102.4C477.867,74.123,454.944,51.2,426.667,51.2z
                                    M443.733,426.667c0,9.426-7.641,17.067-17.067,17.067H51.2c-9.426,0-17.067-7.641-17.067-17.067V204.8h409.6V426.667z
                                    M443.733,170.667h-409.6V102.4c0-9.426,7.641-17.067,17.067-17.067h51.2v34.133c0,9.426,7.641,17.067,17.067,17.067
                                    s17.067-7.641,17.067-17.067V85.333h204.8v34.133c0,9.426,7.641,17.067,17.067,17.067s17.067-7.641,17.067-17.067V85.333h51.2
                                    c9.426,0,17.067,7.641,17.067,17.067V170.667z" />
                                </g>
                              </g>
                              <g>
                                <g>
                                  <path d="M352.98,243.934c-6.614-6.388-17.099-6.388-23.712,0L204.8,368.401l-56.201-56.201c-6.78-6.548-17.584-6.36-24.132,0.419
                                    c-6.388,6.614-6.388,17.099,0,23.713l68.267,68.267c6.665,6.662,17.468,6.662,24.132,0l136.533-136.533
                                    C359.947,261.286,359.759,250.482,352.98,243.934z" />
                                </g>
                              </g>
                            </svg>

                            Schedule
                          </a>
                        </li>
                        <li
                          *ngIf="selectedSalesOrder.crmSalesorderStatus == 'No Show' || selectedSalesOrder.crmSalesorderStatus == 'Cancel'">
                          <a href="javascript:void(0)"
                            (click)="showAppointmentDialog(selectedSalesOrder.crmSalesOrderId,selectedSalesOrder.schAppointmentId)">
                            <svg version="1.1" id="Capa_1" fill="#6F64A7" xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.867 477.867"
                              style="enable-background:new 0 0 477.867 477.867;" xml:space="preserve">
                              <g>
                                <g>
                                  <path d="M426.667,51.2h-51.2V17.067C375.467,7.641,367.826,0,358.4,0s-17.067,7.641-17.067,17.067V51.2h-204.8V17.067
                                    C136.533,7.641,128.892,0,119.467,0S102.4,7.641,102.4,17.067V51.2H51.2C22.923,51.2,0,74.123,0,102.4v324.267
                                    c0,28.277,22.923,51.2,51.2,51.2h375.467c28.277,0,51.2-22.923,51.2-51.2V102.4C477.867,74.123,454.944,51.2,426.667,51.2z
                                    M443.733,426.667c0,9.426-7.641,17.067-17.067,17.067H51.2c-9.426,0-17.067-7.641-17.067-17.067V204.8h409.6V426.667z
                                    M443.733,170.667h-409.6V102.4c0-9.426,7.641-17.067,17.067-17.067h51.2v34.133c0,9.426,7.641,17.067,17.067,17.067
                                    s17.067-7.641,17.067-17.067V85.333h204.8v34.133c0,9.426,7.641,17.067,17.067,17.067s17.067-7.641,17.067-17.067V85.333h51.2
                                    c9.426,0,17.067,7.641,17.067,17.067V170.667z" />
                                </g>
                              </g>
                              <g>
                                <g>
                                  <path d="M352.98,243.934c-6.614-6.388-17.099-6.388-23.712,0L204.8,368.401l-56.201-56.201c-6.78-6.548-17.584-6.36-24.132,0.419
                                    c-6.388,6.614-6.388,17.099,0,23.713l68.267,68.267c6.665,6.662,17.468,6.662,24.132,0l136.533-136.533
                                    C359.947,261.286,359.759,250.482,352.98,243.934z" />
                                </g>
                              </g>
                            </svg>
                            Reschedule
                          </a>
                        </li>
                        <li
                          *ngIf="!selectedSalesOrder.schIsLocked && selectedSalesOrder.crmSalesorderStatus != 'No Show'&& selectedSalesOrder.crmSalesorderStatus != 'Cancel'">
                          <a href="javascript:void(0)"
                            (click)="showVoidSalesOrder('A',selectedSalesOrder.crmSalesOrderId)">
                            <svg id="void-ic-new" xmlns="http://www.w3.org/2000/svg" width="48" height="48"
                              viewBox="0 0 48 48">
                              <path id="Path_1" data-name="Path 1"
                                d="M24,0A24,24,0,1,0,48,24,24,24,0,0,0,24,0ZM4,24A20,20,0,0,1,36.755,8.6L8.6,36.755A19.914,19.914,0,0,1,4,24ZM24,44a19.911,19.911,0,0,1-12.552-4.439L39.56,11.45A19.989,19.989,0,0,1,24,44Z"
                                fill="#6f64a7" />
                            </svg>
                            Void Review
                          </a>
                        </li>
                        <li
                          *ngIf="!selectedSalesOrder.schIsLocked && selectedSalesOrder.crmSalesorderStatus != 'No Show'&& selectedSalesOrder.crmSalesorderStatus != 'Cancel'">
                          <a href="javascript:void(0)"
                            (click)="showVoidSalesOrder('P',selectedSalesOrder.crmSalesOrderId)">
                            <svg id="void-ic-new" xmlns="http://www.w3.org/2000/svg" width="48" height="48"
                              viewBox="0 0 48 48">
                              <path id="Path_1" data-name="Path 1"
                                d="M24,0A24,24,0,1,0,48,24,24,24,0,0,0,24,0ZM4,24A20,20,0,0,1,36.755,8.6L8.6,36.755A19.914,19.914,0,0,1,4,24ZM24,44a19.911,19.911,0,0,1-12.552-4.439L39.56,11.45A19.989,19.989,0,0,1,24,44Z"
                                fill="#6f64a7" />
                            </svg>
                            Void
                          </a>
                        </li>
                        <li
                          *ngIf="!selectedSalesOrder.schIsLocked && (selectedSalesOrder.crmSalesorderStatus == 'No Show' || selectedSalesOrder.crmSalesorderStatus == 'Cancel')">
                          <a href="javascript:void(0)"
                            (click)="showVoidAppointment('A',selectedSalesOrder.schAppointmentId,true)">
                            <svg id="void-ic-new" xmlns="http://www.w3.org/2000/svg" width="48" height="48"
                              viewBox="0 0 48 48">
                              <path id="Path_1" data-name="Path 1"
                                d="M24,0A24,24,0,1,0,48,24,24,24,0,0,0,24,0ZM4,24A20,20,0,0,1,36.755,8.6L8.6,36.755A19.914,19.914,0,0,1,4,24ZM24,44a19.911,19.911,0,0,1-12.552-4.439L39.56,11.45A19.989,19.989,0,0,1,24,44Z"
                                fill="#6f64a7" />
                            </svg>
                            Void Review
                          </a>
                        </li>
                        <li
                          *ngIf="!selectedSalesOrder.schIsLocked && (selectedSalesOrder.crmSalesorderStatus == 'No Show' || selectedSalesOrder.crmSalesorderStatus == 'Cancel')">
                          <a href="javascript:void(0)"
                            (click)="showVoidAppointment('P',selectedSalesOrder.schAppointmentId,true)">
                            <svg id="void-ic-new" xmlns="http://www.w3.org/2000/svg" width="48" height="48"
                              viewBox="0 0 48 48">
                              <path id="Path_1" data-name="Path 1"
                                d="M24,0A24,24,0,1,0,48,24,24,24,0,0,0,24,0ZM4,24A20,20,0,0,1,36.755,8.6L8.6,36.755A19.914,19.914,0,0,1,4,24ZM24,44a19.911,19.911,0,0,1-12.552-4.439L39.56,11.45A19.989,19.989,0,0,1,24,44Z"
                                fill="#6f64a7" />
                            </svg>
                            Void
                          </a>
                        </li>
                      </ul>
                    </p-popover>
                  </td>
                  <td class="table-outer__td appt-so-id" pFrozenColumn>
                    <span class="table-checkbox">
                      <span class="lock-icon" *ngIf="isRowDisabled(salesorder)"
                        pTooltip="Assigned to {{salesorder['schAppointmentLockedByPerson']}}"
                        (click)="Unlock(salesorder,salesorder['schAppointmentLockedBy'] === loggedInUserId)">
                        <svg id="_x31__x2C_5" fill="#868686" enable-background="new 0 0 24 24" height="512"
                          viewBox="0 0 24 24" width="512" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="m18.75 24h-13.5c-1.24 0-2.25-1.009-2.25-2.25v-10.5c0-1.241 1.01-2.25 2.25-2.25h13.5c1.24 0 2.25 1.009 2.25 2.25v10.5c0 1.241-1.01 2.25-2.25 2.25zm-13.5-13.5c-.413 0-.75.336-.75.75v10.5c0 .414.337.75.75.75h13.5c.413 0 .75-.336.75-.75v-10.5c0-.414-.337-.75-.75-.75z" />
                          <path
                            d="m17.25 10.5c-.414 0-.75-.336-.75-.75v-3.75c0-2.481-2.019-4.5-4.5-4.5s-4.5 2.019-4.5 4.5v3.75c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-3.75c0-3.309 2.691-6 6-6s6 2.691 6 6v3.75c0 .414-.336.75-.75.75z" />
                          <path
                            d="m12 17c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0-2.5c-.275 0-.5.224-.5.5s.225.5.5.5.5-.224.5-.5-.225-.5-.5-.5z" />
                          <path
                            d="m12 20c-.414 0-.75-.336-.75-.75v-2.75c0-.414.336-.75.75-.75s.75.336.75.75v2.75c0 .414-.336.75-.75.75z" />
                        </svg>
                      </span>

                      <p-tableCheckbox class="table-check-first" *ngIf="!isRowDisabled(salesorder)" [value]="salesorder"
                        [disabled]="isRowDisabled(salesorder)"></p-tableCheckbox>

                      <a (click)="onNavigateBrightTreeSalesOrderUrl(salesorder.crmSalesOrderAPPId)"
                        href="javascript:void(0)" pTooltip="{{salesorder.crmSalesOrderAPPId}}"
                        tooltipPosition="top">{{salesorder.crmSalesOrderAPPId}}</a>

                    </span>

                  </td>
                  <td class="table-outer__td appt-patient-name" pFrozenColumn>
                    <span class="patient">
                      <a class="text-ellipsis" href="javascript:void(0)"
                        (click)="onView(salesorder.crmSalesOrderId,salesorder.crmSalesorderStatus,salesorder.schAppointmentId)"
                        pTooltip="{{salesorder.crmPatientName}}" tooltipPosition="top">
                        {{salesorder.crmPatientName}}
                      </a>
                      <span class="bright-tree-patient-url">
                        <a (click)="onNavigateBrightTreePatientUrl(salesorder['crmPatientBrightreeID'])"
                          href="javascript:void(0)">{{salesorder['crmPatientId']}}</a>
                        | {{salesorder['crmPatientBirthdate'] | date:appDateFormat.dateFormat }}
                      </span>
                    </span>
                  </td>
                  <td class="table-outer__td appt-classification" pFrozenColumn>
                    <span class="text-ellipsis"
                      pTooltip="{{salesorder.crmClassification}}">{{salesorder.crmClassification}}</span>
                  </td>
                  <td class="table-outer__td appt-status" pFrozenColumn>
                    <p [ngClass]="salesorder.crmSalesorderStatus=='Cancel'?'cancel':salesorder.crmSalesorderStatus=='No Show'?'no-show':'ready-for-scheduling'"
                      class="status-block-box">
                    </p>
                  </td>

                  <!-- All Display Column none then it will show *ngIf="isOnlyNonSFixedColumnVisible" -->
                  <!-- <ng-container styleClass="displaycolumn">
                    <td class="table-outer__td table-outer__displaycolumn"></td>
                  </ng-container> -->


                  <ng-container *ngFor="let col of columns">
                    <td class="table-outer__td" *ngIf="col.visible===true && col.field == 'crmIsCallBack'">
                      <span *ngIf="salesorder['crmIsCallBack']"> Callback Request </span>
                      <span *ngIf="!salesorder['crmIsCallBack']" pTooltip="{{salesorder['crmCallCount']==0 ?'Awaiting First Call':
                             salesorder['crmCallCount']==1?'Awaiting Second Call':
                             salesorder['crmCallCount']==2?'Awaiting Third Call':
                             salesorder['crmCallCount']==3?'Awaiting Fourth Call':
                             salesorder['crmCallCount']==4?'Awaiting Fifth Call':
                             salesorder['crmCallCount']==5?'Awaiting Sixth Call':
                             salesorder['crmCallCount']==6?'Awaiting Seventh Call':
                             salesorder['crmCallCount']==7?'Awaiting Eighth Call':
                             salesorder['crmCallCount']==8?'Awaiting Ninth Call':
                             'Awaiting Tenth Call'}}" tooltipPosition="top">
                        {{
                        salesorder['crmCallCount']==0 ?'Awaiting First Call':
                        salesorder['crmCallCount']==1 ?'Awaiting Second Call':
                        salesorder['crmCallCount']==2 ?'Awaiting Third Call':
                        salesorder['crmCallCount']==3 ?'Awaiting Fourth Call':
                        salesorder['crmCallCount']==4 ?'Awaiting Fifth Call':
                        salesorder['crmCallCount']==5 ?'Awaiting Sixth Call':
                        salesorder['crmCallCount']==6 ?'Awaiting Seventh Call':
                        salesorder['crmCallCount']==7 ?'Awaiting Eighth Call':
                        salesorder['crmCallCount']==8 ?'Awaiting Ninth Call':'Awaiting Tenth Call'}}
                      </span>
                    </td>
                    <td class="table-outer__td" *ngIf="col.visible===true && col.field == 'dateTimeCreated'">
                      <span class="date-time dateTimeCreated">
                        {{salesorder['dateTimeCreated']|date:appDateFormat.dateFormat}}
                        <p>{{salesorder['dateTimeCreated'] | date:'shortTime' | lowercase}}</p>
                      </span>
                    </td>
                    <td class="table-outer__td" *ngIf="col.visible===true && col.field == 'crmRequestCallBackDate'">
                      <span class="date-time dateTimeCreated">
                        {{salesorder['crmRequestCallBackDate'] | date:appDateFormat.dateFormat}}
                        <p>
                          {{salesorder['crmRequestCallBackDate'] | date:'shortTime' | lowercase}}
                          <span *ngIf="salesorder['crmRequestCallBackDate'] != null" class="timezone-code">
                            {{salesorder['timeZone'] | timezone}}
                          </span>
                        </p>
                      </span>
                    </td>
                    <td class="table-outer__td"
                      *ngIf="col.visible===true && col.field != 'crmIsCallBack' && col.field != 'dateTimeCreated' && col.field != 'crmRequestCallBackDate'">
                      <span class="text-ellipsis" tooltipPosition="left" pTooltip="{{salesorder[col.field]}}"
                        *ngIf="col.field !='amountDue' && col.field != 'crmClassificaitonduration' && col.field != 'lastCallDate' && col.field != 'timeZone'">{{salesorder[col.field]}}</span>
                      <span class="list-classification-type" *ngIf="col.field=='amountDue'">
                        ${{
                        salesorder[col.field]
                        }}
                      </span>
                      <span class="dateTimeCreated"
                        *ngIf="col.field=='crmClassificaitonduration'">{{salesorder[col.field] }} Minutes</span>
                      <span *ngIf="col.field == 'lastCallDate'">
                        {{salesorder['lastCallDate'] | date:appDateFormat.dateFormat}}
                        <p>{{salesorder['lastCallDate'] | date:'shortTime' | lowercase}}</p>
                      </span>
                      <span class="text-ellipsis" *ngIf="col.field=='timeZone'">{{salesorder[col.field] | timezone}}
                      </span>
                    </td>
                  </ng-container>
                </tr>
              </ng-template>

              <ng-template pTemplate="paginatorleft" class="table-pagination">
                <span class="table-pagination__records">
                  Total Records : &nbsp;<strong> {{totalRecords}}</strong>
                </span>
              </ng-template>
              <ng-template pTemplate="paginatorright" class="table-pagination">
                <span class="table-pagination__select">

                  <p-select class="select-box" panelStyleClass="paginetion-selectbox" appendTo="body" [options]="pageSiges" [(ngModel)]="selectedpage"
                    id="branchDropdown" placeholder="Select Page" optionLabel="name" filter="false"

                    (onChange)="onPageChange($event)"></p-select>
                </span>
              </ng-template>

            </p-table>
            <div class="no-records-found-appointment" *ngIf="!loading && !dataExpressionloading && totalRecords <= 0"
              [attr.colspan]="NsheduledTableDefaltColumns + selectedNonSColumns.length">
              No records found
            </div>
          </div>
        </div>

      </ng-template>
    </p-tabPanel>

    <p-tabPanel header="Scheduled" class="dummyClassSch">
      <!--<app-scheduled-appointments></app-scheduled-appointments>-->
      <ng-template pTemplate="content">

        <a *ngIf="false" class="appt-table-action-click" href="javascript:void(0);"
          (click)="actionsClickScheduled.toggle($event)">Actions</a>

        <p-popover appendTo="body" #actionsClickScheduled [dismissable]="true">
          <div class="appt-listing-action">
            <div class="appt-listing-action__block">
              <ul>
                <li *ngFor="let salesOrderCount of appointmentCountModels;let i=index">
                  <a href="javascript:void(0);"
                    [ngClass]="{'active': i===selectedfilterSIndex,'inactive': i!=selectedfilterSIndex,'nocursor': salesOrderCount.salesOrderCount== 0}"
                    (click)="salesOrderCount.salesOrderCount > 0 &&  onAppointmentCountClick(salesOrderCount,i);">
                    <span class="text">
                      {{salesOrderCount.salesOrderStatusDisplayble}}
                    </span>
                    <span class="numbers"
                      (click)="salesOrderCount.salesOrderCount > 0 && onSalesOrderCountClick(salesOrderCount,i);">{{salesOrderCount.salesOrderCount}}</span>

                  </a>
                </li>
              </ul>
            </div>
          </div>
        </p-popover>

        <div *ngIf="false" class="appointments-top-block" [ngClass]="clickEventFilterStatus ? 'active' : 'inactive'">

          <div class="appointments-top-block__box"
            [ngClass]="{'active': i===selectedfilterSIndex,'inactive': i!=selectedfilterSIndex,'nocursor': salesOrderCount.salesOrderCount== 0}"
            *ngFor="let salesOrderCount of appointmentCountModels;let i=index">
            <span class="appointments-top-block__box__numbers"
              (click)="salesOrderCount.salesOrderCount > 0 &&  onAppointmentCountClick(salesOrderCount,i);">{{salesOrderCount.salesOrderCount}}</span>
            <div (click)="salesOrderCount.salesOrderCount > 0 && onAppointmentCountClick(salesOrderCount,i);">
              {{salesOrderCount.salesOrderStatusDisplayble}}
            </div>
          </div>
        </div>

        <div class="appointments-table-filer">

          <div class="appointments-table-filer__appit-legend">
            <ul>
              <li>
                <span class="legend all-legend" (click)="onAppointmentStatusCountClick('')">
                  All Appointments
                  ({{appointmentsStatusCount?.none >0 ? appointmentsStatusCount?.none : 0}})
                </span>
              </li>
              <li>
                <span class="legend upcoming" (click)="onAppointmentStatusCountClick('Booked')">
                  Upcoming
                  ({{appointmentsStatusCount?.booked >0 ? appointmentsStatusCount?.booked : 0}})
                </span>
              </li>
              <li>
                <span class="legend unreconciled" (click)="onAppointmentStatusCountClick('unReconcile')">
                  Unreconciled
                  ({{appointmentsStatusCount?.unReconcile >0 ? appointmentsStatusCount?.unReconcile : 0}})
                </span>
              </li>
            </ul>
          </div>

          <div class="appointments-table-filer__sort-by" *ngIf="appointmentsalesOrderStatusMenuitems?.length>0">
            <div class="from__group list-search-outer">
              <div class="search-box">
                <input type="text" class="form__control" pInputText size="50" placeholder="S/O ID, Patient & DOB"
                  #searchBoxAppointment #formInput (keyup.enter)="onScheduledSearchButtonClick();">

                <button *ngIf="searchBoxAppointment.value !=''" class="clear-btn" type="button"
                  (click)="searchBoxAppointment.value =''; onScheduledSearchButtonClick();">
                  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.6524 1.54489L1.23901 13.5955M13.6524 13.5955L1.23901 1.54489L13.6524 13.5955Z"
                      stroke="#363636" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </button>

                <button class="search-btn cursor" pButton type="button">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M6.84236 13.684C7.52019 13.6838 8.18931 13.5825 8.8288 13.387C10.1919 12.9704 11.7882 12.9978 12.7961 14.0056L14.186 15.3954C14.5199 15.7293 15.0613 15.7293 15.3953 15.3954C15.7292 15.0614 15.7292 14.5199 15.3953 14.186L14.0057 12.7965C12.9978 11.7886 12.9706 10.1922 13.3874 8.82909C13.5831 8.18941 13.6846 7.52007 13.6847 6.84199C13.6847 3.06949 10.6151 0 6.84236 0C3.06965 0 0 3.06949 0 6.84199C0 10.6145 3.06965 13.684 6.84236 13.684ZM6.84236 1.7105C9.67253 1.7105 11.9741 4.01197 11.9741 6.84199C11.9741 9.67201 9.67253 11.9735 6.84236 11.9735C4.01219 11.9735 1.71059 9.67201 1.71059 6.84199C1.71059 4.01197 4.01219 1.7105 6.84236 1.7105Z"
                      fill="#3E3E3E" />
                  </svg>
                </button>
              </div>
            </div>

            <a href="javascript:void(0);" class="filter-show-hide" (click)="Op1.toggle($event)" pTooltip="Actions"
              tooltipPosition="left">
              <svg width="21" height="5" viewBox="0 0 21 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="2.5" cy="2.5" r="2.5" fill="#707070"></circle>
                <circle cx="10.5" cy="2.5" r="2.5" fill="#707070"></circle>
                <circle cx="18.5" cy="2.5" r="2.5" fill="#707070"></circle>
              </svg>
            </a>

            <p-popover #Op1 appendTo="body" class="search-filter">
              <div class="quick-link-menu">
                <ul>
                  <li *ngIf="isSendInvitationPermission">
                    <a class="invite-schedule" routerLinkActive="active" href="javascript:void(0)"
                      (click)="SendInvitationforScheduledAppointment();">Send Invite</a>
                  </li>

                  <li *ngFor="let item of appointmentsalesOrderStatusMenuitems">
                    <a *ngIf="CheckItemToDisable(item.id)" class="invite-schedule" href="javascript:void(0)"
                      (click)="onMenuSelection(item)">{{item.label}}</a>
                  </li>
                  <li>
                    <a class="invite-schedule" href="javascript:void(0)"
                      (click)="totalAppointmentRecords > 0 ? CancelVoidAllAppointmentS('cancel',false):''">Cancel</a>
                  </li>
                  <li>
                    <a class="invite-schedule" href="javascript:void(0)"
                      (click)="totalAppointmentRecords > 0 ? CancelVoidAllAppointmentS('voidreview',false):''">
                      Void
                      Review
                    </a>
                  </li>
                  <li>
                    <a class="invite-schedule" href="javascript:void(0)"
                      (click)="totalAppointmentRecords > 0 ? CancelVoidAllAppointmentS('void',false):''">Void</a>
                  </li>
                  <li>
                    <a class="invite-schedule" href="javascript:void(0)"
                      (click)="totalAppointmentRecords > 0 ? ExportS():''">Export</a>
                  </li>
                  <li>
                    <a class="invite-schedule" href="javascript:void(0)"
                      (click)="totalAppointmentRecords > 0 ? SendVoiceMail(false): ''">Voice Mail</a>
                  </li>
                </ul>
              </div>
            </p-popover>


            <a href="javascript:void(0);" class="filter-block" (click)="ScheduledTableColumn.toggle($event)"
              pTooltip="Column Display Settings" tooltipPosition="left" positionStyle="column-display">
              <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.0525 2.89474H15.2104" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M11.4211 1V4.78946" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M11.421 2.89474H1" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M4.78946 9.5263H1" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M8.57886 7.63157V11.421" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M18.9999 9.5263H8.57886" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M18.0525 16.1579H15.2104" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M11.4211 14.2631V18.0526" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M11.421 16.1579H1" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </a>

            <a href="javascript:void(0);" class="filter-block filter-block filter-show-hide" pTooltip="Filters"
              tooltipPosition="right" (click)="tableFilterScheduled.toggle($event)">
              <img src="assets/img/filter-ic.svg" width="18" alt="filters">
            </a>

            <p-popover #tableFilterScheduled class="search-filter" [dismissable]="true" showCloseIcon="true">
              <!-- appit-shheduled-search -->
              <div class="search-box-outer">
                <h2 class="filter-title">Filters</h2>
                 <a href="javascript:void(0);" class="filter-close" (click)="tableFilterScheduled.toggle($event); onClearSHFilterSearch();">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                    <path d="M18.2116 2.8568L2.78845 18.1432" stroke="#3E3E3E" stroke-width="2.5"/>
                    <path d="M18.143 18.2116L2.85657 2.78844" stroke="#3E3E3E" stroke-width="2.5"/>
                  </svg>
                </a>
                <div class="form__group full-width quick-date-filter-box mr-0">
                  <label class="form__label">Appointment Date Filters</label>
                  <div class="search-box">
                    <input matInput class="form__control" ngxDaterangepickerMd placeholder="Quick Filters"
                      [showCustomRangeLabel]="true" [alwaysShowCalendars]="true" [customRangeDirection]="true"
                      [(ngModel)]="SSelectedDateRange" [ranges]="sRanges" [showCancel]="true" [linkedCalendars]="true"
                      [isTooltipDate]="isTooltipDate" [isInvalidDate]="isInvalidDate" [locale]="callocales"
                      [keepCalendarOpeningWithRange]="true" [showClearButton]="true" [showRangeLabelOnInput]="true" />

                    <button class="search-btn">
                      <i class="search-new"></i>
                    </button>
                  </div>
                </div>

                <div class="from__group">
                  <label class="form__label">Branch</label>
                  <p-select class="form__dropdown select-box" filter="true"  [options]="branchResponseModel"
                    [(ngModel)]="selectedSbranch" id="branchDropdown" placeholder="Select Branch"
                    optionLabel="crmBranchName" (onChange)="onBranchSChange($event)"></p-select>
                </div>
                <div class="from__group">
                  <label class="form__label">Classification Type</label>
                  <p-multiSelect class="form__multiSelect select-box" [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="selectedClassificationType" [options]="filterClassificationList" placeholder="Select"
                    (onChange)="onClassificationTypeChange($event.value)" optionLabel="crmClassificationDisplayName"
                    [showToggleAll]="false" [selectionLimit]="5"
                    selectedItemsLabel="{0} Classification Selected"></p-multiSelect>
                  <small>[You can select max 5 items at a time]</small>
                </div>
                <!-- full-width -->
                <div class="from__group">
                  <label class="form__label">Time Zone</label>
                  <p-multiSelect class="form__multiSelect select-box" [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="selectedTimeZone" [options]="timeZoneList" placeholder="Select"
                    (onChange)="onTimeZoneChange($event.value)" optionLabel="appStandardTimeZoneName"
                    selectedItemsLabel="{0} Time Zone Selected"></p-multiSelect>
                </div>

                <div class="from__group">
                  <label class="form__label">Primary Insurance</label>
                  <p-multiSelect class="form__multiSelect select-box" [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="selectedPrimaryInsuranceProvider" [options]="primaryInsuranceProviderList"
                    placeholder="Select" (onChange)="onPrimaryInsurationProviderChange($event.value)"
                    optionLabel="crmPolicyHolderName" [showToggleAll]="false" [selectionLimit]="5"
                    selectedItemsLabel="{0} Primary Insurance Provider Selected"></p-multiSelect>
                  <small>[You can select max 5 items at a time]</small>
                </div>


                <div class="btn-block">
                  <button class="btn btn--primary"
                    (click)="onSCHSearch();closeSearchFilter($event, tableFilterScheduled);">Search</button>
                  <a class="btn btn--secondary clear-filter" href="javascript:void(0)"
                    (click)="onClearSHFilterSearch();onSCHSearch();">
                    Clear
                  </a>
                </div>

                <div class="form__group custome-date-select" *ngIf="customNSDate">
                  <p-calendar [ngModelOptions]="{standalone: true}" hourFormat="12" #cal1 class="datepicker"
                    placeholder="From Date" dateFormat="mm/dd/yy" [showIcon]="true" [(ngModel)]="searchFromNSDate">

                  </p-calendar>
                  <p-calendar [ngModelOptions]="{standalone: true}" hourFormat="12" #cal1 class="datepicker"
                    placeholder="To Date" dateFormat="mm/dd/yy" [showIcon]="true" [(ngModel)]="searchToNSDate">
                  </p-calendar>
                  <button class="btn btn--primary" (click)="onCustomDateSSearchButtonClick()">
                    <i class="search-new"></i>
                  </button>
                </div>
              </div>
            </p-popover>

          </div>
        </div>

        <div class="page-scroll appointments-list"
          [ngClass]="filterShowHideSchedule ? 'filter-active' : 'filter-inactive'">
          <div class="appointments-scroll-inner-side">
            <!-- <div class="appointment-actionmenu add-table-column" *ngIf="totalAppointmentRecords > 0">
              <a href="javascript:void(0)" (click)="ScheduledTableColumn.toggle($event)" pTooltip="Column Display Settings"
                tooltipPosition="right">
                <svg height="512pt" fill="#656565" viewBox="0 0 512 512" width="512pt"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="m256 512c-141.164062 0-256-114.835938-256-256s114.835938-256 256-256 256 114.835938 256 256-114.835938 256-256 256zm0-480c-123.519531 0-224 100.480469-224 224s100.480469 224 224 224 224-100.480469 224-224-100.480469-224-224-224zm0 0" />
                  <path
                    d="m368 272h-224c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h224c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0" />
                  <path
                    d="m256 384c-8.832031 0-16-7.167969-16-16v-224c0-8.832031 7.167969-16 16-16s16 7.167969 16 16v224c0 8.832031-7.167969 16-16 16zm0 0" />
                </svg>
              </a>

            </div> -->
            <p-table #tableAppointment [ngClass]="isOnlySFixedColumnVisible ? 'onlyvisiblecolumn' : ''"
              class="table-outer appt-scheduled" sortMode="single" sortField="CrmPatientName"
              [first]="searchAppointmentRequestModel.FirstRecordIndex" [sortOrder]="1" [value]="appointments"
              [paginator]="totalAppointmentRecords>0?true:false" [rows]="getAppointmentTotalRows()"
              [totalRecords]="totalAppointmentRecords" [lazy]="true" [customSort]="true"
              (onLazyLoad)="onAppointmentLazyLoad($event)" [(selection)]="selectedAppointments" selectionMode=""
              (selectionChange)="onSelectionSChange($event)" [columns]="userSPreferenceColumn" [scrollable]="true"
              scrollHeight="calc(100vh - 258px)" dataKey="schAppointmentId" scrollDirection="both">

              <ng-template pTemplate="header" let-columns>
                <tr *ngIf="totalAppointmentRecords > 0">
                  <th class="table-outer__th appt-action-column" pFrozenColumn></th>
                  <th class="table-outer__th appt-so-id" pFrozenColumn>
                    <span class="table-header-flex">
                      <p-tableHeaderCheckbox #headerSCheckBox></p-tableHeaderCheckbox>
                      <span class="header-soid__name">S/O ID</span>
                    </span>
                  </th>
                  <th class="table-outer__th appt-patient-name" pFrozenColumn pSortableColumn="crmPatientName">
                    Patient details
                    <p-sortIcon field="crmPatientName"></p-sortIcon>
                  </th>
                  <th class="table-outer__th appt-classification" pFrozenColumn pSortableColumn="crmClassification">
                    Classification Type
                    <p-sortIcon field="crmClassification"></p-sortIcon>
                  </th>
                  <th class="table-outer__th appt-status" pFrozenColumn pSortableColumn="schAppointmentStatus">
                    Status
                    <p-sortIcon field="schAppointmentStatus"></p-sortIcon>
                  </th>

                  <ng-container *ngFor="let co of columns">
                    <th
                      *ngIf="co.field != 'crmPatientName && crmClassification && schAppointmentStatus' && co.visible===true"
                      class="table-outer__th" pSortableColumn="{{co.sortFieldName}}">
                      {{co.header}}
                      <p-sortIcon field="{{co.field}}"></p-sortIcon>
                    </th>
                  </ng-container>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-salesorder let-columns="columns">
                <tr [ngClass]="salesorder.schAppointmentBookedBy==0?'appBookMyPatient':''">

                  <td class="table-outer__td appt-action-column" pFrozenColumn>
                    <a class="actionmenu-btn" href="javascript:void(0)"
                      (click)="selectScheduleSalesOrder($event,salesorder,ScheduledTableaction)">
                      <!-- <i class="ic action-ic"></i> -->
                      <svg id="Layer_1" class="appt-action-icon" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 29.96 122.88">
                        <path class="cls-1"
                          d="M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Zm0,92.93a15,15,0,1,1-15,15,15,15,0,0,1,15-15Zm0-46.47a15,15,0,1,1-15,15,15,15,0,0,1,15-15Z" />
                      </svg>
                    </a>
                    <p-popover class="table-action-popup NotScheduledAction appointment-Action"
                      #ScheduledTableaction>
                      <ul class="quick-link-menu">

                        <li *ngIf="isAppointmentRescheduledPermission">
                          <a href="javascript:void(0)"
                            (click)="showAppointmentDialog(selectedAppointment.crmSalesorderId,selectedAppointment.schAppointmentId)">
                            <svg version="1.1" id="Capa_1" fill="#6F64A7" xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.867 477.867"
                              style="enable-background:new 0 0 477.867 477.867;" xml:space="preserve">
                              <g>
                                <g>
                                  <path d="M426.667,51.2h-51.2V17.067C375.467,7.641,367.826,0,358.4,0s-17.067,7.641-17.067,17.067V51.2h-204.8V17.067
                                    C136.533,7.641,128.892,0,119.467,0S102.4,7.641,102.4,17.067V51.2H51.2C22.923,51.2,0,74.123,0,102.4v324.267
                                    c0,28.277,22.923,51.2,51.2,51.2h375.467c28.277,0,51.2-22.923,51.2-51.2V102.4C477.867,74.123,454.944,51.2,426.667,51.2z
                                    M443.733,426.667c0,9.426-7.641,17.067-17.067,17.067H51.2c-9.426,0-17.067-7.641-17.067-17.067V204.8h409.6V426.667z
                                    M443.733,170.667h-409.6V102.4c0-9.426,7.641-17.067,17.067-17.067h51.2v34.133c0,9.426,7.641,17.067,17.067,17.067
                                    s17.067-7.641,17.067-17.067V85.333h204.8v34.133c0,9.426,7.641,17.067,17.067,17.067s17.067-7.641,17.067-17.067V85.333h51.2
                                    c9.426,0,17.067,7.641,17.067,17.067V170.667z" />
                                </g>
                              </g>
                              <g>
                                <g>
                                  <path d="M352.98,243.934c-6.614-6.388-17.099-6.388-23.712,0L204.8,368.401l-56.201-56.201c-6.78-6.548-17.584-6.36-24.132,0.419
                                    c-6.388,6.614-6.388,17.099,0,23.713l68.267,68.267c6.665,6.662,17.468,6.662,24.132,0l136.533-136.533
                                    C359.947,261.286,359.759,250.482,352.98,243.934z" />
                                </g>
                              </g>
                            </svg>
                            Reschedule
                          </a>
                        </li>
                        <li *ngIf="!selectedSalesOrder.schIsLocked && isAppointmentCancelPermission">
                          <a href="javascript:void(0)"
                            (click)="showCancelAppointment(selectedAppointment.schAppointmentId)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
                              <g id="Group_1" data-name="Group 1" transform="translate(-268 -186)">
                                <g id="_1" data-name="1" transform="translate(217.73 138)">
                                  <path id="Path_1" data-name="Path 1"
                                    d="M72.27,92a22,22,0,1,1,22-22A22.024,22.024,0,0,1,72.27,92Zm0-40.807A18.807,18.807,0,1,0,91.077,70,18.829,18.829,0,0,0,72.27,51.193Z"
                                    fill="#6f64a7" />
                                  <path id="Path_2" data-name="Path 2"
                                    d="M175.959,177.635a1.6,1.6,0,0,1-1.129-.467L156.543,158.88a1.6,1.6,0,1,1,2.257-2.257l18.288,18.288a1.6,1.6,0,0,1-1.129,2.724Z"
                                    transform="translate(-94.546 -96.645)" fill="#6f64a7" />
                                  <path id="Path_3" data-name="Path 3"
                                    d="M157.678,177.634a1.6,1.6,0,0,1-1.128-2.724l18.287-18.288a1.6,1.6,0,1,1,2.258,2.257l-18.288,18.288A1.6,1.6,0,0,1,157.678,177.634Z"
                                    transform="translate(-94.552 -96.644)" fill="#6f64a7" />
                                </g>
                              </g>
                            </svg>
                            Cancel
                          </a>
                        </li>
                        <li *ngIf="!selectedSalesOrder.schIsLocked">
                          <a href="javascript:void(0)"
                            (click)="showVoidAppointment('A',selectedAppointment.schAppointmentId,false)">
                            <svg id="void-ic-new" xmlns="http://www.w3.org/2000/svg" width="48" height="48"
                              viewBox="0 0 48 48">
                              <path id="Path_1" data-name="Path 1"
                                d="M24,0A24,24,0,1,0,48,24,24,24,0,0,0,24,0ZM4,24A20,20,0,0,1,36.755,8.6L8.6,36.755A19.914,19.914,0,0,1,4,24ZM24,44a19.911,19.911,0,0,1-12.552-4.439L39.56,11.45A19.989,19.989,0,0,1,24,44Z"
                                fill="#6f64a7" />
                            </svg>
                            Void Review
                          </a>
                        </li>
                        <li *ngIf="!selectedSalesOrder.schIsLocked">
                          <a href="javascript:void(0)"
                            (click)="showVoidAppointment('P',selectedAppointment.schAppointmentId,false)">
                            <svg id="void-ic-new" xmlns="http://www.w3.org/2000/svg" width="48" height="48"
                              viewBox="0 0 48 48">
                              <path id="Path_1" data-name="Path 1"
                                d="M24,0A24,24,0,1,0,48,24,24,24,0,0,0,24,0ZM4,24A20,20,0,0,1,36.755,8.6L8.6,36.755A19.914,19.914,0,0,1,4,24ZM24,44a19.911,19.911,0,0,1-12.552-4.439L39.56,11.45A19.989,19.989,0,0,1,24,44Z"
                                fill="#6f64a7" />
                            </svg>
                            Void
                          </a>
                        </li>
                      </ul>
                    </p-popover>
                  </td>
                  <td class="table-outer__td appt-so-id" pFrozenColumn>
                    <span class="table-checkbox">
                      <p-tableCheckbox [value]="salesorder"></p-tableCheckbox>
                      <a pTooltip="{{salesorder.crmSalesOrderAPPId}}"
                        (click)="onNavigateBrightTreeSalesOrderUrl(salesorder.crmSalesOrderAPPId)"
                        href="javascript:void(0)">{{salesorder.crmSalesOrderAPPId}}</a>
                    </span>
                  </td>
                  <td class="table-outer__td appt-patient-name" pFrozenColumn>
                    <span class="patient">
                      <a href="javascript:void(0)" (click)="onAppointmentView(salesorder.schAppointmentId)"
                        pTooltip="{{salesorder['crmPatientName']}}" tooltipPosition="top"
                        class="text-ellipsis">{{salesorder['crmPatientName']}}</a>

                      <span class="bright-tree-patient-url">
                        <a (click)="onNavigateBrightTreePatientUrl(salesorder['crmPatientBrightreeID'])"
                          href="javascript:void(0)">{{salesorder['crmPatientId']}}</a>
                        {{salesorder['crmPatientBirthdate'] | date:appDateFormat.dateFormat}}
                      </span>
                    </span>
                  </td>
                  <td class="table-outer__td appt-classification" pFrozenColumn>
                    <span pTooltip="{{salesorder.crmClassification}}"
                      class="text-ellipsis">{{salesorder.crmClassification}}</span>
                  </td>
                  <td class="table-outer__td appt-status" pFrozenColumn>

                    <span *ngIf="salesorder['schIsUnreconciledAppointment']"
                      class="status-block-box unreconciled"></span>

                    <span class="status-block-box"
                      *ngIf="!this.isUnreconciled && !salesorder['schIsUnreconciledAppointment']"
                      [ngClass]="salesorder.schAppointmentStatus=='Booked'?'upcoming':salesorder.schAppointmentStatus=='Complete'?'complete':salesorder.schAppointmentStatus=='NoShow'?'no-show':'unreconciled'">
                    </span>
                  </td>
                  <ng-container *ngFor="let col of columns">
                    <td class="table-outer__td" *ngIf="col.visible===true && col.field == 'crmDoctorName'">
                      <span class="text-ellipsis"
                        pTooltip="{{salesorder.crmDoctorName}}">{{salesorder.crmDoctorName}}</span>
                    </td>
                    <td class="table-outer__td" *ngIf="col.visible===true && col.field == 'crmBranch'">
                      <span class="text-ellipsis" pTooltip="{{salesorder.crmBranch}}">{{salesorder.crmBranch}}</span>
                    </td>
                    <td class="table-outer__td" *ngIf="col.visible===true && col.field == 'schAppointmentDateTime'">
                      <span class="date-time">
                        <span>{{salesorder['schAppointmentDateTime'] | date:appDateFormat.dateFormat}}</span>
                        <p>
                          {{salesorder['schAppointmentDateTime'] | date:'shortTime' | lowercase}}<span
                            class="timezone-code">{{salesorder['crmPatientTimeZone'] | timezone}} </span>
                        </p>
                      </span>
                    </td>
                    <td class="table-outer__td" *ngIf="col.visible===true && col.field == 'schRTAppointmentDateTime'">
                      <span class="date-time">
                        <span>{{salesorder['schRTAppointmentDateTime'] | date:appDateFormat.dateFormat}}</span>
                        <p>
                          {{salesorder['schRTAppointmentDateTime'] | date:'shortTime' | lowercase}}<span
                            class="timezone-code">{{salesorder['crmFacilityTimeZone'] | timezone}} </span>
                        </p>
                      </span>
                    </td>
                    <td class="table-outer__td" *ngIf="col.visible===true && col.field == 'appTherapistName'">
                      <span class="text-ellipsis"
                        pTooltip="{{salesorder.appTherapistName}}">{{salesorder.appTherapistName}}</span>
                    </td>

                    <td class="table-outer__td"
                      *ngIf="col.visible===true && col.field != 'crmDoctorName' && col.field != 'crmBranch' && col.field != 'schAppointmentDateTime'
                    && col.field != 'schRTAppointmentDateTime' && col.field != 'appTherapistName' && col.field != 'lastCallDate'">
                      <span class="text-ellipsis" tooltipPosition="left" pTooltip="{{salesorder[col.field]}}"
                        *ngIf="col.field !='amountDue' && col.field != 'crmClassificaitonduration' && col.field != 'crmFacilityTimeZone' && col.field != 'crmPatientTimeZone'">{{salesorder[col.field]}}</span>
                      <span class="list-classification-type" *ngIf="col.field=='amountDue'">
                        ${{
                        salesorder[col.field]
                        }}
                      </span>
                      <span class="dateTimeCreated"
                        *ngIf="col.field=='crmClassificaitonduration'">{{salesorder[col.field] }} Minutes</span>
                      <span class="text-ellipsis" *ngIf="col.field=='crmFacilityTimeZone'">{{salesorder[col.field] |
                        timezone}} </span>
                      <span class="text-ellipsis" *ngIf="col.field=='crmPatientTimeZone'">{{salesorder[col.field] |
                        timezone}} </span>
                    </td>
                    <td class="table-outer__td" *ngIf="col.visible===true && col.field == 'lastCallDate'">
                      <span class="date-time">
                        <span>{{salesorder['lastCallDate'] | date:appDateFormat.dateFormat}}</span>
                        <p>{{salesorder['lastCallDate'] | date:'shortTime' | lowercase}}</p>
                      </span>
                    </td>
                  </ng-container>

                </tr>
              </ng-template>

              <ng-template pTemplate="paginatorleft" class="table-pagination">
                <span class="table-pagination__records">
                  Total Records: &nbsp;<strong> {{totalAppointmentRecords}}</strong>
                </span>
              </ng-template>
              <ng-template pTemplate="paginatorright" class="table-pagination">
                <span class="table-pagination__select">

                  <p-select class="select-box" panelStyleClass="paginetion-selectbox" appendTo="body" [options]="pageSiges" [(ngModel)]="selectedpageNS"

                    id="branchDropdownNS" placeholder="Select Page" optionLabel="name" filter="false"
                    (onChange)="onPageChangeNS($event)" ></p-select>
                </span>
              </ng-template>

            </p-table>

            <div class="no-records-found-appointment"
              *ngIf="!loading && !dataExpressionloading && totalAppointmentRecords <= 0"
              [attr.colspan]="sheduledTableDefaltColumns + selectedColumns.length">
              No records found
            </div>
          </div>
        </div>

      </ng-template>
    </p-tabPanel>

  </p-tabView>
  <div class="loader-block" *ngIf="loading">
    <p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="8" fill="#ffffff" animationDuration=".8s">
    </p-progressSpinner>
  </div>
</div>

<!-- Not Scheduled Column Display Settings Popup -->
<p-popover styleClass="overlayPanel-add-column-popup" class="add-column-popup" #NotScheduledAddColumn>
  <div class="column-display-settings">
    <h3 class="column-display-settings__title">Column Display Settings</h3>
    <div class="column-display-settings__scroll">
      <ul class="quick-link-menu column-display-settings__list" cdkDropList (cdkDropListDropped)="dropNon($event)">
        <li class="column-display-settings__items" *ngFor="let col of userNonSPreferenceColumn" cdkDrag>
          <span class="column-display-settings__icon" cdkDragHandle>
            <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M1.8 15.5C1.305 15.5 0.881101 15.3162 0.528301 14.9487C0.175501 14.5812 -0.000598472 14.14 1.52801e-06 13.625C1.52801e-06 13.1094 0.176401 12.6678 0.529201 12.3003C0.882001 11.9328 1.3056 11.7494 1.8 11.75C2.295 11.75 2.7189 11.9337 3.0717 12.3012C3.4245 12.6687 3.6006 13.11 3.6 13.625C3.6 14.1406 3.4236 14.5822 3.0708 14.9497C2.718 15.3172 2.2944 15.5006 1.8 15.5ZM7.2 15.5C6.705 15.5 6.2811 15.3162 5.9283 14.9487C5.5755 14.5812 5.3994 14.14 5.4 13.625C5.4 13.1094 5.5764 12.6678 5.9292 12.3003C6.282 11.9328 6.7056 11.7494 7.2 11.75C7.695 11.75 8.1189 11.9337 8.4717 12.3012C8.8245 12.6687 9.0006 13.11 9 13.625C9 14.1406 8.8236 14.5822 8.4708 14.9497C8.118 15.3172 7.6944 15.5006 7.2 15.5ZM1.8 9.875C1.305 9.875 0.881101 9.69125 0.528301 9.32375C0.175501 8.95625 -0.000598472 8.515 1.52801e-06 8C1.52801e-06 7.48438 0.176401 7.04281 0.529201 6.67531C0.882001 6.30781 1.3056 6.12438 1.8 6.125C2.295 6.125 2.7189 6.30875 3.0717 6.67625C3.4245 7.04375 3.6006 7.485 3.6 8C3.6 8.51562 3.4236 8.95719 3.0708 9.32469C2.718 9.69219 2.2944 9.87562 1.8 9.875ZM7.2 9.875C6.705 9.875 6.2811 9.69125 5.9283 9.32375C5.5755 8.95625 5.3994 8.515 5.4 8C5.4 7.48438 5.5764 7.04281 5.9292 6.67531C6.282 6.30781 6.7056 6.12438 7.2 6.125C7.695 6.125 8.1189 6.30875 8.4717 6.67625C8.8245 7.04375 9.0006 7.485 9 8C9 8.51562 8.8236 8.95719 8.4708 9.32469C8.118 9.69219 7.6944 9.87562 7.2 9.875ZM1.8 4.25C1.305 4.25 0.881101 4.06625 0.528301 3.69875C0.175501 3.33125 -0.000598472 2.89 1.52801e-06 2.375C1.52801e-06 1.85938 0.176401 1.41781 0.529201 1.05031C0.882001 0.682814 1.3056 0.499377 1.8 0.500002C2.295 0.500002 2.7189 0.683751 3.0717 1.05125C3.4245 1.41875 3.6006 1.86 3.6 2.375C3.6 2.89063 3.4236 3.33219 3.0708 3.69969C2.718 4.06719 2.2944 4.25063 1.8 4.25ZM7.2 4.25C6.705 4.25 6.2811 4.06625 5.9283 3.69875C5.5755 3.33125 5.3994 2.89 5.4 2.375C5.4 1.85938 5.5764 1.41781 5.9292 1.05031C6.282 0.682814 6.7056 0.499377 7.2 0.500002C7.695 0.500002 8.1189 0.683751 8.4717 1.05125C8.8245 1.41875 9.0006 1.86 9 2.375C9 2.89063 8.8236 3.33219 8.4708 3.69969C8.118 4.06719 7.6944 4.25063 7.2 4.25Z"
                fill="#B0A3EF" />
            </svg>
          </span>
          <div class="column-display-settings__text">
            <p-checkbox name="columns" [binary]="true" inputId="{{col.header}}" [(ngModel)]="col.preferenceVisible" />
            <label for="{{col.header}}">{{col.header}}</label>
          </div>
        </li>
      </ul>
    </div>
    <div class="column-display-settings__buttons">
      <button class="btn btn--primary"
        (click)="AddNonSColumnInTable($event,userNonSPreferenceColumn);NotScheduledAddColumn.hide()">Save
        Changes</button>
      <button class="btn btn--secondary" (click)="CancelNonSColumn($event, NotScheduledAddColumn);">Cancel</button>
    </div>
  </div>
</p-popover>

<!-- Scheduled Column Display Settings Popup -->
<p-popover styleClass="overlayPanel-add-column-popup" class="add-column-popup" #ScheduledTableColumn>
  <div class="column-display-settings">
    <h3 class="column-display-settings__title">Column Display Settings</h3>
    <div class="column-display-settings__scroll">
      <ul class="quick-link-menu column-display-settings__list" cdkDropList (cdkDropListDropped)="dropS($event)">
        <li class="column-display-settings__items" *ngFor="let col of userSPreferenceColumn" cdkDrag>
          <span class="column-display-settings__icon" cdkDragHandle>
            <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M1.8 15.5C1.305 15.5 0.881101 15.3162 0.528301 14.9487C0.175501 14.5812 -0.000598472 14.14 1.52801e-06 13.625C1.52801e-06 13.1094 0.176401 12.6678 0.529201 12.3003C0.882001 11.9328 1.3056 11.7494 1.8 11.75C2.295 11.75 2.7189 11.9337 3.0717 12.3012C3.4245 12.6687 3.6006 13.11 3.6 13.625C3.6 14.1406 3.4236 14.5822 3.0708 14.9497C2.718 15.3172 2.2944 15.5006 1.8 15.5ZM7.2 15.5C6.705 15.5 6.2811 15.3162 5.9283 14.9487C5.5755 14.5812 5.3994 14.14 5.4 13.625C5.4 13.1094 5.5764 12.6678 5.9292 12.3003C6.282 11.9328 6.7056 11.7494 7.2 11.75C7.695 11.75 8.1189 11.9337 8.4717 12.3012C8.8245 12.6687 9.0006 13.11 9 13.625C9 14.1406 8.8236 14.5822 8.4708 14.9497C8.118 15.3172 7.6944 15.5006 7.2 15.5ZM1.8 9.875C1.305 9.875 0.881101 9.69125 0.528301 9.32375C0.175501 8.95625 -0.000598472 8.515 1.52801e-06 8C1.52801e-06 7.48438 0.176401 7.04281 0.529201 6.67531C0.882001 6.30781 1.3056 6.12438 1.8 6.125C2.295 6.125 2.7189 6.30875 3.0717 6.67625C3.4245 7.04375 3.6006 7.485 3.6 8C3.6 8.51562 3.4236 8.95719 3.0708 9.32469C2.718 9.69219 2.2944 9.87562 1.8 9.875ZM7.2 9.875C6.705 9.875 6.2811 9.69125 5.9283 9.32375C5.5755 8.95625 5.3994 8.515 5.4 8C5.4 7.48438 5.5764 7.04281 5.9292 6.67531C6.282 6.30781 6.7056 6.12438 7.2 6.125C7.695 6.125 8.1189 6.30875 8.4717 6.67625C8.8245 7.04375 9.0006 7.485 9 8C9 8.51562 8.8236 8.95719 8.4708 9.32469C8.118 9.69219 7.6944 9.87562 7.2 9.875ZM1.8 4.25C1.305 4.25 0.881101 4.06625 0.528301 3.69875C0.175501 3.33125 -0.000598472 2.89 1.52801e-06 2.375C1.52801e-06 1.85938 0.176401 1.41781 0.529201 1.05031C0.882001 0.682814 1.3056 0.499377 1.8 0.500002C2.295 0.500002 2.7189 0.683751 3.0717 1.05125C3.4245 1.41875 3.6006 1.86 3.6 2.375C3.6 2.89063 3.4236 3.33219 3.0708 3.69969C2.718 4.06719 2.2944 4.25063 1.8 4.25ZM7.2 4.25C6.705 4.25 6.2811 4.06625 5.9283 3.69875C5.5755 3.33125 5.3994 2.89 5.4 2.375C5.4 1.85938 5.5764 1.41781 5.9292 1.05031C6.282 0.682814 6.7056 0.499377 7.2 0.500002C7.695 0.500002 8.1189 0.683751 8.4717 1.05125C8.8245 1.41875 9.0006 1.86 9 2.375C9 2.89063 8.8236 3.33219 8.4708 3.69969C8.118 4.06719 7.6944 4.25063 7.2 4.25Z"
                fill="#B0A3EF" />
            </svg>
          </span>
          <div class="column-display-settings__text">
            <p-checkbox name="columns" inputId="{{col.header}}" [binary]="true" [(ngModel)]="col.preferenceVisible" />
            <label for="{{col.header}}">{{col.header}}</label>
          </div>
        </li>
      </ul>
    </div>

    <div class="column-display-settings__buttons">
      <button class="btn btn--primary"
        (click)="AddSColumnInTable($event,userSPreferenceColumn);ScheduledTableColumn.hide()">Save Changes</button>
      <button class="btn btn--secondary" (click)="CancelSColumn($event, ScheduledTableColumn);">Cancel</button>
    </div>
  </div>
</p-popover>


<!-- Cancel Appointment popup -->
<p-dialog [(visible)]="displayCancelAppointment" styleClass="display-close-icon" [modal]="true" appendTo="body">
  <div class="popup-content-outer cancel-appointment">
    <h2>Cancel Appointment</h2>
    <div class="schedulecall">
      <form class="form" [formGroup]="formCancel" autocomplete="off" *ngIf="formCancel">
        <div class="schedulecall">
          <div class="col">
            <div class="form__group full-width">
              <label class="form__label">Reason</label>
              <p-select class="form__dropdown" filter="true"  [options]="cancellationReasonsResponseModel" formControlName="reason"
                placeholder="Select Reason" optionLabel="salesOrderVoidReason" ></p-select>

              <div *ngIf="formCancelSubmitted && fCancel.reason.errors" class="invalid-feedback-error">
                <span *ngIf="fCancel.reason.errors.required || fCancel.reason.errors.whitespace">
                  {{validationMessages.reason.required}}
                </span>

              </div>
            </div>
          </div>
          <div class="col">
            <div class="form__group full-width">
              <label class="form__label">Comment</label>

              <textarea class="form__textarea" pInputTextarea formControlName="reasonComments"
                maxlength="100"></textarea>
              <div *ngIf="formCancelSubmitted && fCancel.reasonComments.errors" class="invalid-feedback-error">
                <span *ngIf="fCancel.reasonComments.errors.required || fCancel.reasonComments.errors.whitespace">
                  {{validationMessages.reasonComments.required}}
                </span>
              </div>

            </div>
          </div>
          <div class="col">
            <div class="check receive-reminder wip-state-will-not-update">
               <span class="form__checkbox-outer">
                <p-checkbox name="groupnamecancel" label="If box checked, the WIP State will not be updated in Brightree"
                  [(ngModel)]="isBrightreeSystemAppUpdate" binary="true" (onChange)="onBTSelect($event)"
                  [ngModelOptions]="{standalone: true}" inputId="IfboxcheckedtheWIPState1">
                </p-checkbox>
                <label class="form__checkbox-label" for="IfboxcheckedtheWIPState1">If box checked, the WIP State will not be updated in Brightree</label>
              </span>
            </div>
          </div>
          <div class="appointment-calcel-btn">
            <button class="btn btn--primary" (click)="cancelAppointment()">Submit</button>
            <a href="javascript:void(0)" class="btn btn--secondary" (click)="hideAppointmentpopup()">Cancel</a>
          </div>
        </div>
      </form>
    </div>
  </div>
</p-dialog>

<!-- Void Appointment popup -->
<p-dialog [(visible)]="displayVoidAppointment" styleClass="display-close-icon" [modal]="true" appendTo="body">
  <div class="popup-content-outer cancel-appointment">
    <h2>Void Appointment</h2>
    <div class="schedulecall">
      <form class="form" [formGroup]="formVoidAppointment" autocomplete="off" *ngIf="formVoidAppointment">
        <div class="schedulecall">

          <div class="col">
            <div class="form__group full-width">
              <label class="form__label">Reason</label>
              <p-select class="form__dropdown" filter="true"  [options]="voidReasonsResponseModel" filter="true" formControlName="voidReason"
                placeholder="Select Reason" optionLabel="salesOrderVoidReason" ></p-select>
              <div *ngIf="formVoidAppointmentSubmitted && fVoid.voidReason.errors" class="invalid-feedback-error">
                <span *ngIf="fVoid.voidReason.errors.required || fVoid.voidReason.errors.whitespace">
                  {{validationMessages.voidReason.required}}
                </span>

              </div>
            </div>
          </div>
          <div class="col">
            <div class="form__group full-width">
              <label class="form__label">Comment</label>
              <textarea class="form__textarea" pInputTextarea formControlName="voidReasonComments"
                maxlength="100"></textarea>
              <div *ngIf="formVoidAppointmentSubmitted && fVoid.voidReasonComments.errors"
                class="invalid-feedback-error">
                <span *ngIf="fVoid.voidReasonComments.errors.required || fVoid.voidReasonComments.errors.whitespace">
                  {{validationMessages.voidReasonComments.required}}
                </span>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="check receive-reminder wip-state-will-not-update">
              <span class="form__checkbox-outer">
              <p-checkbox name="groupnamevoid" label="If box checked, the WIP State will not be updated in Brightree"
                [(ngModel)]="isBrightreeSystemAppUpdate" binary="true" (onChange)="onBTSelect($event)"
                [ngModelOptions]="{standalone: true}" inputClass="IfboxcheckedtheWIPState2">
              </p-checkbox>
              <label class="form__checkbox-label" for="IfboxcheckedtheWIPState2">If box checked, the WIP State will not be updated in Brightree</label> 
              </span>
            </div>
          </div>
          <div class="call-popup-appointment">
            <button class="btn btn--primary" (click)="voidAppointment(voidFrom)">Submit</button>
            <a href="javascript:void(0)" class="btn btn--secondary" (click)="cancelVoidAppointment()">Cancel</a>
          </div>
        </div>
      </form>
    </div>
  </div>
</p-dialog>

<!-- NoShow Appointment popup -->
<p-dialog [(visible)]="displayNoShowAppointment" styleClass="display-close-icon" [modal]="true" appendTo="body">
  <div class="popup-content-outer cancel-appointment">
    <h2>No Show Appointment</h2>
    <div class="schedulecall">

      <div class="col">
        <div class="form__group full-width">
          <label class="form__label">Are you sure you want to no show appointment ?</label>
        </div>
      </div>
      <div class="schedulecall">
        <div class="col">
          <div class="form__group full-width">
            <label class="form__label">Comment</label>

            <textarea class="form__textarea" pInputTextarea [(ngModel)]="reasonCommentsNoShow"
              maxlength="100"></textarea>
          </div>
        </div>
        <div class="col">
          <div class="check receive-reminder wip-state-will-not-update">
            <span class="form__checkbox-outer">
              <p-checkbox name="groupnamenoshow" label="If box checked, the WIP State will not be updated in Brightree"
                [(ngModel)]="isBrightreeSystemAppUpdate" binary="true" (onChange)="onBTSelect($event)"
                [ngModelOptions]="{standalone: true}" inputId="IfboxcheckedtheWIPState">
              </p-checkbox>
              <label class="form__checkbox-label" for="IfboxcheckedtheWIPState">If box checked, the WIP State will not be updated in Brightree</label>
            </span>
          </div>
        </div>

        <div class="appointment-calcel-btn">
          <button class="btn btn--primary" (click)="NoShowAppointment()">Submit</button>
          <a href="javascript:void(0)" class="btn btn--secondary" (click)="hideNoShowPopup()">Cancel</a>
        </div>
      </div>

    </div>
  </div>
</p-dialog>

<!-- Complete Appointment popup -->
<p-dialog [(visible)]="displayCompleteAppointment" styleClass="display-close-icon" [modal]="true" appendTo="body">
  <div class="popup-content-outer cancel-appointment">
    <h2>Complete Appointment</h2>
    <div class="schedulecall">

      <div class="schedulecall">
        <div class="col">
          <div class="form__group full-width" style="margin-bottom: .5rem;">
            <label class="form__label">Are you sure you want to complete appointment ?</label>
          </div>
        </div>
        <div class="col">
          <div class="form__group full-width">
            <label class="form__label">Comment</label>

            <textarea class="form__textarea" pInputTextarea [(ngModel)]="reasonCommentsComplete"
              maxlength="100"></textarea>
          </div>
        </div>
        <div class="col">
          <div class="check receive-reminder wip-state-will-not-update">
            <span class="form__checkbox-outer">
              <p-checkbox name="groupnamecomplete" label="If box checked, the WIP State will not be updated in Brightree"
                [(ngModel)]="isBrightreeSystemAppUpdate" binary="true" (onChange)="onBTSelect($event)"
                [ngModelOptions]="{standalone: true}" inputId="IfboxcheckedtheWIPStateComplete">
              </p-checkbox>
              <label class="form__checkbox-label" for="IfboxcheckedtheWIPStateComplete">If box checked, the WIP State will not be updated in Brightree</label> 
            </span>
          </div>
        </div>

        <div class="appointment-calcel-btn">
          <button class="btn btn--primary" (click)="CompleteAppointment()">Submit</button>
          <a href="javascript:void(0)" class="btn btn--secondary" (click)="hideCompletePopup()">Cancel</a>
        </div>
      </div>

    </div>
  </div>
</p-dialog>

<p-dialog [(visible)]="ConfirmInvitePatients" styleClass="display-close-icon" [modal]="true" appendTo="body">
  <div class="popup-content-outer confirm-invite-patients">
    <div *ngIf="restrictedSalesOrderIdToSendInvite?.length != totalSelectedSendInviteSalesOrderIds">
      <h2>Confirm Sending Invitation to Patients</h2>
      <div *ngIf="restrictedSalesOrderIdToSendInvite?.length==0">
        <div class="confirm-invite-patients__content-part">
          <p>
            You are about to send an invitation to {{totalSelectedSendInviteSalesOrderIds}} patient(s). Please click
            <strong>
              “Yes,
              confirm”
            </strong> to send an invitation to {{totalSelectedSendInviteSalesOrderIds}} patient(s).
          </p>
        </div>
      </div>

      <div *ngIf="restrictedSalesOrderIdToSendInvite?.length>0">
        <div class="confirm-invite-patients__content-part">
          <p>
            You have selected {{totalSelectedSendInviteSalesOrderIds}} patient(s), but
            {{restrictedSalesOrderIdToSendInvite?.length}} of them are not eligible to receive the invitation, because
            the self-scheduling service is disabled in their branch.
          </p>
          <p *ngIf="restrictedSalesOrderIdToSendInvite?.length>0">
            Please click <strong>
              “Yes,
              confirm”
            </strong> to send an invitation to {{
            totalSelectedSendInviteSalesOrderIds -
            restrictedSalesOrderIdToSendInvite?.length
            }} patient(s).
          </p>
          <p><strong>The following patient(s) are not eligible to receive an invitation:</strong></p>
        </div>
        <div class="popup-table-outer">
          <table class="custom-table">
            <thead>
              <tr>
                <th>S/O ID</th>
                <th>Patient Name</th>
                <th>Branch</th>
              </tr>
            </thead>
            <tbody *ngFor="let restrictedSalesOrder of restrictedSalesOrderIdToSendInvite">
              <tr>
                <td>{{restrictedSalesOrder.crmSalesOrderAPPId}}</td>
                <td>{{restrictedSalesOrder.crmPatientName | titlecase}}</td>
                <td>{{restrictedSalesOrder.crmBranch}}</td>
              </tr>
            </tbody>

          </table>
        </div>
      </div>

      <div class="confirm-invite-patients__buttons-box">
        <a href="javascript:void(0)" class="btn btn--secondary" (click)="ConfirmInvitePatientsCancel()">No, Cancel</a>
        <button class="btn btn--primary" (click)="ConfirmSendInvitePatients()">Yes, Confirm</button>
      </div>
    </div>

    <div *ngIf="restrictedSalesOrderIdToSendInvite?.length == totalSelectedSendInviteSalesOrderIds">
      <h2>Can't Send Invitation to Patients</h2>
      <div class="confirm-invite-patients__content-part">
        <p>You can't send an invitation to the selected patients because the self-scheduling service is disabled for
          their branch.</p>
      </div>

      <div class="confirm-invite-patients__buttons-box">
        <button class="btn btn--primary" (click)="ConfirmInvitePatientsCancel()">Ok</button>
      </div>
    </div>
  </div>
</p-dialog>

<!-- 41466: This is to restrict No Show appointment status -->
<p-dialog [(visible)]="ConfirmSetStatusChange" styleClass="display-close-icon" [modal]="true" appendTo="body">
  <div class="popup-content-outer confirm-invite-patients">
    <div *ngIf="restrictedApptForStatus?.length != totalSelectedNoShowAppointments">
      <h2>Confirm Setting {{statusType}} Status to Appointments</h2>
      <div *ngIf="restrictedApptForStatus?.length==0">
        <div class="confirm-invite-patients__content-part">
          <p>
            You are about to set {{statusType}} status to {{totalSelectedNoShowAppointments}} appointment(s). Please
            click <strong>
              “Yes,
              confirm”
            </strong> to set {{statusType}} status to {{totalSelectedNoShowAppointments}} appointment(s).
          </p>
        </div>
      </div>

      <div *ngIf="restrictedApptForStatus?.length>0">
        <div class="confirm-invite-patients__content-part">
          <p>
            You have selected {{totalSelectedNoShowAppointments}} patient(s), but {{restrictedApptForStatus?.length}} of
            them are not eligible for {{statusType}} status, because Appointments time is not due yet.
          </p>
          <p *ngIf="restrictedApptForStatus?.length>0">
            Please click <strong>
              “Yes,
              confirm”
            </strong> to set {{statusType}} status to {{
            totalSelectedNoShowAppointments -
            restrictedApptForStatus?.length
            }} patient(s).
          </p>
          <p><strong>The following patient(s) appointments are not eligible to set {{statusType}} Status:</strong></p>
        </div>
        <div class="popup-table-outer">
          <table class="custom-table">
            <thead>
              <tr>
                <th>S/O ID</th>
                <th>Patient Name</th>
                <th>Appointment Time</th>
                <!-- <th>Time Zone</th> -->
              </tr>
            </thead>
            <tbody *ngFor="let restrictedAppointment of restrictedApptForStatus">
              <tr>
                <td>{{restrictedAppointment.crmSalesOrderAPPId}}</td>
                <td>{{restrictedAppointment.crmPatientName | titlecase}}</td>
                <td>{{restrictedAppointment.schAppointmentDateTime}}</td>
                <!-- <td>{{restrictedAppointment.crmPatientTimeZone | timezone}}</td> -->
              </tr>
            </tbody>

          </table>
        </div>
      </div>

      <div class="confirm-invite-patients__buttons-box">
        <a href="javascript:void(0)" class="btn btn--secondary" (click)="ConfirmSetStatusCancel()">No, Cancel</a>
        <button class="btn btn--primary" (click)="ConfirmSetStatusAppoinments()">Yes, Confirm</button>
      </div>
    </div>

    <div *ngIf="restrictedApptForStatus?.length == totalSelectedNoShowAppointments">
      <h2>Can't Set {{statusType}} Status To Selected Appointments</h2>
      <div class="confirm-invite-patients__content-part">
        <p>You can't set {{statusType}} status to the selected appointments because the Appointment time is not due yet.
        </p>
      </div>

      <div class="confirm-invite-patients__buttons-box">
        <button class="btn btn--primary" (click)="ConfirmSetStatusCancel()">Ok</button>
      </div>
    </div>
  </div>
</p-dialog>